import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { TabelaPreco } from '@mobile/models/cardapio/cardapio.model';

@Injectable({ providedIn: 'root' })
export class TabelasPrecoFirebaseService {
  constructor(private afs: AngularFirestore) {}

  async getAll(): Promise<TabelaPreco[]> {
    const snapshot = await this.afs.firestore.collection('TabelasPreco').get();
    return snapshot.docs.map(d => d.data() as TabelaPreco);
  }
}
